import React from 'react';

import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';

import { CTA_NAMES } from '@/utils/rudderstack';

import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';

import { UpsellCard } from '../../../_components/UpsellCard';

import { trackClickEvent } from '../../utils';

export type LayoutNoSubscriptionProps = {
  t: TypePlayKitPageTranslations;
  childUuid?: string;
};

function LayoutNoSubscription({ t, childUuid }: LayoutNoSubscriptionProps) {
  const ctaLink = `/pages/subscription-v3/child-info${childUuid ? `?childUuid=${childUuid}` : ''}`;

  return (
    <div data-testid="layout-no-subscription" className="text-center">
      <HeaderText
        classes="pb-2"
        size={HeaderSize.H1}
        align="left"
        text={t.noActiveSubscription}
      />
      <UpsellCard
        headerText={t.exploreThePlayKits}
        subText={t.exploreThePlayKitsSubtext}
        ctaText={t.exploreThePlayKits}
        ctaLink={ctaLink}
        onClick={() => {
          trackClickEvent(CTA_NAMES.EXPLORE_THE_PLAY_KITS);
        }}
      />
    </div>
  );
}

export default LayoutNoSubscription;
